import Company from 'models/Profile/Company';
import { CompanyGroup } from 'models/Profile/CompanyGroups';
import addCompaniesToCompanyGroup from './AddCompaniesToCompanyGroup';
import groupCompaniesGroupById from './GroupCompaniesGroup';

const groupCompanies = (companiesArray : Array<Company>, currentModule : string) : Array<CompanyGroup> => {
  if(companiesArray.length == 0)
    return [];

  const companies : Array<Company> = cloneArray(companiesArray);
  const groups = getAllGroups(companies);

  const currentCompanyGroup = getCurrentProduct(groups, currentModule);

  if(!currentCompanyGroup || currentCompanyGroup.length === 0)
    return [];

  const companyGroup = groupCompaniesGroupById(currentCompanyGroup);

  return addCompaniesToCompanyGroup(companyGroup, companies);
};

function cloneArray(companies : Array<Company>) : Array<Company> {
  return JSON.parse(JSON.stringify(companies));
}

function getAllGroups(companies : Array<Company>) : Array<CompanyGroup> {
  const groups = companies.map(x => x.groups);
  return groups.flat();
}

function getCurrentProduct(groups : Array<CompanyGroup>, currentModule : string) : Array<CompanyGroup> {
  return groups.filter(group => group?.noun.toLocaleLowerCase() === currentModule.toLocaleLowerCase());
}

export default groupCompanies;